import dynamic from 'next/dynamic';

export const UIBottomSheet = dynamic(
  () => import('./bottomSheetInternal').then((mod) => mod.UIBottomSheet),
  {
    ssr: false,
  }
);

// export { UIBottomSheet } from './bottomSheetInternal';
